



































































































































































































































































































































































































































































































































import { mapGetters, mapState } from 'vuex'
import ClassifiedSearchResultsRowActionsStats from '~/components/car/classifieds/search/results/ClassifiedSearchResultsRowActionsStats.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import { faChartPie } from '@fortawesome/free-solid-svg-icons'
import { CLASSIFIED_SEARCH_ACTIONS_NS } from '~/store/modules/shared/classifieds/search/actions/state'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { ViewType } from '~/models/shared/types'
import PromoteModal from '~/components/car/classifieds/search/promotion/PromoteModal.vue'
import BackgroundJobsBadge from '~/components/car/classifieds/search/results/rows/main/partials/BackgroundJobs/BackgroundJobsBadge.vue'
import CButton from '~/components/shared/configurable/button/CButton.vue'
import CButtonGroup from '~/components/shared/configurable/button/CButtonGroup.vue'
import AutoTouchService from '~/services/auto-touch/AutoTouchService'
import { mapDeps } from '~/plugins/dependency-container/utils'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import UrlOpenerService from '~/services/url/UrlOpenerService'
import { CategoryId } from '~/models/category/types'
import { Permission } from '~/constants/permission'
import { ciAutoTouch } from '~/icons/source/solid/auto-touch'
import { ciCredit } from '~/icons/source/regular/credit'
import { hideAllPoppers } from 'floating-vue'
import { ciTradesMatch } from '~/icons/source/regular/trades-match'
import { ciTouch } from '~/icons/source/solid/touch'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import DeleteClassifiedModalContent from '~/components/car/classifieds/edit/DeleteClassifiedModalContent.vue'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { ciTrash } from '~/icons/source/solid/trash'
import { ciEdit } from '~/icons/source/solid/edit'
import { ciCopy } from '~/icons/source/solid/copy'
import { ciStar } from '~/icons/source/solid/star'
import { ciExclamationCircle } from '~/icons/source/solid/exclamation-circle'
import { ciEye } from '~/icons/source/solid/eye'
import { ciEyeSlash } from '~/icons/source/solid/eye-slash'
import { ciEnvelope } from '~/icons/source/solid/envelope'
import { ciUndo } from '~/icons/source/solid/undo'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import CAutoTouchModal from '~/components/shared/configurable/CAutoTouchModal.vue'
import DiscountsDisableClassifiedButton from '~/components/car/classifieds/search/results/rows/main/partials/Actions/ActionButtons/DiscountsDisableClassifiedButton.vue'
import DiscountsDisableUserButton from '~/components/car/classifieds/search/results/rows/main/partials/Actions/ActionButtons/DiscountsDisableUserButton.vue'
import { format } from '~/utils/date'
import { ClassifiedSearchResultRow } from '~/models/search/types'
import { ciPartsAccessories } from '~/icons/source/solid/parts-accessories'

export default defineComponent({
  components: {
    DeleteClassifiedModalContent,
    BackgroundJobsBadge,
    PromoteModal,
    ClassifiedSearchResultsRowActionsStats,
    CButton,
    CButtonGroup,
    CConfirmationModal,
    CAutoTouchModal,
    DiscountsDisableClassifiedButton,
    DiscountsDisableUserButton
  },
  props: {
    classified: {
      type: Object as PropType<ClassifiedSearchResultRow>,
      required: true
    },
    categoryIds: {
      type: Array,
      required: true
    },
    requiresPayment: {
      type: Boolean,
      required: false,
      default: false
    },
    viewType: {
      type: String as PropType<ViewType>,
      required: false,
      default: ViewType.LIST
    },
    classifiedBackgroundJobs: {
      type: Object,
      default: null
    },
    showActionsLabels: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showModal: false,
      hovering: false,
      showPromoModal: false,
      isAutoTouchModalVisible: false,
      showNoCreditsPopover: false,
      noCreditsPopoverTimeout: null,
      deleteReason: null,
      showConvertConfirm: false
    }
  },
  computed: {
    ...mapDeps({
      legacyUrlService: LegacyUrlService
    }),
    formattedDeletedDate() {
      if (!this.classified.deletedDate) {
        return ''
      }

      return format(this.classified.deletedDate)
    },
    autoTouchButtonVariant() {
      if (this.classified.autoTouch?.lastTouchError) {
        return 'danger'
      } else {
        return 'secondary'
      }
    },
    showDisableButtons() {
      return this.inBlackFridaySearch || this.inDealsSearch
    },
    hasLastTouchError() {
      return this.classified?.autoTouch?.lastTouchError
    },
    visibilitySettings() {
      const options = {
        variant: {
          normal: {
            hidden: { variant: 'danger', outline: true },
            visible: { variant: 'success', outline: true }
          },
          hover: {
            hidden: { variant: 'success', outline: false },
            visible: { variant: 'danger', outline: false }
          }
        },
        label: {
          normal: {
            hidden: this.$t('hidden::classified'),
            visible: this.$t('shown::classified')
          },
          hover: {
            hidden: this.$t('show'),
            visible: this.$t('hide')
          }
        },
        icon: {
          normal: {
            visible: ciEye,
            hidden: ciEyeSlash
          },
          hover: {
            hidden: ciEye,
            visible: ciEyeSlash
          }
        }
      }
      const hoverState = this.hovering ? 'hover' : 'normal'
      const isHidden = this.userIsAdmin
        ? this.classified.states.isNonPublic
        : this.classified.states.isHidden
      const visibilityState = isHidden ? 'hidden' : 'visible'
      return {
        variant: options.variant[hoverState][visibilityState].variant,
        outline: options.variant[hoverState][visibilityState].outline,
        icon: options.icon[hoverState][visibilityState],
        label: options.label[hoverState][visibilityState]
      }
    },
    copyUrl() {
      const { id, categoryIds } = this.classified
      return this.legacyUrlService.getCompatibilityCopyUrl(categoryIds, id)
    },
    statisticsUrl() {
      return `/classifieds/${this.classified.id}/edit/statistics/`
    },
    icons() {
      return {
        trash: ciTrash,
        touch: ciTouch,
        restore: ciUndo,
        edit: ciEdit,
        copy: ciCopy,
        part: ciPartsAccessories,
        envelope: ciEnvelope,
        star: ciStar,
        stats: faChartPie,
        autoTouch: ciAutoTouch,
        warn: ciExclamationCircle,
        credit: ciCredit,
        trades: ciTradesMatch
      }
    },
    ...mapState(CLASSIFIED_SEARCH_ACTIONS_NS, {
      actionPending: (state: boolean) => state.pending,
      noCreditsForClassified: (state: boolean) => state.noCreditsForClassified
    }),
    ...mapGetters(CLASSIFIED_SEARCH_NS, [
      'inBlackFridaySearch',
      'inDealsSearch'
    ]),
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin',
      userIsSingle: 'isSingle',
      userHasPermission: 'hasPermission',
      userHasFeatureToggle: 'userHasFeatureToggle'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    autoTouchService() {
      return this.$dep(AutoTouchService)
    },
    showConvertToPartButton() {
      return this.categoryIds.includes(CategoryId.VEHICLES)
    },
    classifiedIsDeleted() {
      return this.classified.states.isDeleted
    },
    classifiedIsRemoved() {
      return this.classified.states.isRemoved
    },
    classifiedPromotionAvailable() {
      return this.classified.promotion && this.classified.promotion.available
    },
    showPromoteButton() {
      return (
        (this.classifiedPromotionAvailable &&
          this.userHasPermission(Permission.CLASSIFIED_PROMOTIONS)) ||
        this.userIsSingle
      )
    },
    showTradesButton() {
      return this.classified?.trades?.enabled
    },
    tradesLink() {
      return this.$router.resolve({
        name: '__trades_page',
        params: { cid: this.classified.id }
      }).href
    },
    classifiedIsPromoted() {
      return (
        this.classified.promotion &&
        this.classified.promotion.activePromotion &&
        this.classified.promotion.activePromotion.isPromoted
      )
    },
    activePromotion() {
      if (this.classifiedIsPromoted) {
        return this.classified.promotion.activePromotion
      }
      return null
    },
    autoTouchText(): string {
      if (this.classified.autoTouch) {
        return this.autoTouchService.schedulerText(this.classified.autoTouch)
      }
      return this.$t('renewal scheduler')
    },
    showDeleteOptions() {
      return ![CategoryId.RENTALS, CategoryId.JOBS].some(c =>
        this.classified.categoryIds.includes(c)
      )
    }
  },
  watch: {
    noCreditsForClassified(newVal) {
      if (newVal === this.classified.id) {
        this.displayNoCreditsPopover()
      }
    }
  },
  methods: {
    onAutoTouchButtonClick() {
      this.$analytics.recordEvent({
        namespace: 'n_classified_search_row_actions',
        action: 'click',
        label: 'autotouch'
      })

      this.isAutoTouchModalVisible = true
    },
    onCopyButtonClick() {
      this.$analytics.recordEvent({
        namespace: 'n_classified_search_row_actions',
        action: 'click',
        label: 'copy'
      })

      this.openUrlInNewTab(this.copyUrl)
    },
    onEditButtonClick() {
      this.$analytics.recordEvent({
        namespace: 'n_classified_search_row_actions',
        action: 'click',
        label: 'edit'
      })

      this.openUrlInNewTab(`/classifieds/${this.classified.id}/edit/`)
    },
    onTradeButtonClick() {
      this.$analytics.recordEvent({
        namespace: 'n_classified_search_row_actions',
        action: 'click',
        label: 'trades'
      })
    },
    onPromoteButtonClick() {
      this.$analytics.recordEvent({
        namespace: 'n_classified_search_row_actions',
        action: 'click',
        label: 'promote'
      })

      this.showPromoModal = true
    },
    onTouchButtonClick() {
      this.$analytics.recordEvent({
        namespace: 'n_classified_search_row_actions',
        action: 'click',
        label: 'touch'
      })

      this.$emit('touch', this.classified.id)
    },
    hideNoCreditsPopover() {
      if (this.noCreditsPopoverTimeout || this.showNoCreditsPopover) {
        clearInterval(this.noCreditsPopoverTimeout)
        this.showNoCreditsPopover = false
      }
    },
    displayNoCreditsPopover() {
      const secs = 6000
      this.hideNoCreditsPopover()
      this.$nextTick(() => {
        this.noCreditsPopoverTimeout = setTimeout(() => {
          this.showNoCreditsPopover = false
        }, secs)
        hideAllPoppers()
        this.showNoCreditsPopover = true
      })
    },
    toggleVisibility() {
      this.$analytics.recordEvent({
        namespace: 'n_classified_search_row_actions',
        action: 'click',
        label: 'visibility'
      })

      if (this.classified.states.isHidden) {
        this.$emit('show', this.classified.id)
      } else {
        this.$emit('hide', this.classified.id)
      }
    },
    toggleAdminVisibility() {
      if (this.classified.states.isNonPublic) {
        this.$emit('show-to-public', this.classified.id)
      } else {
        this.$emit('hide-from-public', this.classified.id)
      }
    },
    openUrlInNewTab(url: string) {
      const urlOpenerService = this.$dep(UrlOpenerService)
      urlOpenerService.openUrlInNewTab(url)
    },
    deleteClassified(e, isAdmin: boolean) {
      if (!this.deleteReason && this.showDeleteOptions && !isAdmin) {
        e.preventDefault()
        this.$snackbar.error(this.$t('delete_reason'))
        return
      }
      this.$emit('delete', {
        id: this.classified.id,
        reason: this.deleteReason
      })
    },
    onDeleteButtonClick(e) {
      if (this.userIsAdmin) {
        this.deleteClassified(e, true)
      } else {
        this.$analytics.recordEvent({
          namespace: 'n_classified_search_row_actions',
          action: 'click',
          label: 'delete'
        })

        this.showModal = true
      }
    }
  }
})
